import { useState } from "react";
import { useSelector } from "react-redux";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type IFlightNumberFilter,
  type IFlightNumbersByAirlineCode,
  type PlatformComponentProps,
} from "@b2bportal/core-types";
import { CheckboxGroup, RadioGroup } from "@tenant/ui";
import clsx from "clsx";
import { airlinesSelector } from "../../../shop/store";
import defaultStyles from "./FilterFlightNumber.module.scss";

export interface FilterFlightNumber extends PlatformComponentProps {
  selectedFlightNumber: IFlightNumberFilter[];
  flightNumbersByAirline: IFlightNumbersByAirlineCode;
  onFlightNumberChange: (val: IFlightNumberFilter[]) => void;
}
export const FilterFlightNumber = ({
  selectedFlightNumber,
  flightNumbersByAirline,
  className,
  onFlightNumberChange,
}: FilterFlightNumber) => {
  const COMPONENT_KEY = CoreFlightsComponent.FilterFlightNumber;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [block, cn] = useModuleBEM(styles, COMPONENT_KEY);

  const [airlineCode, setAirlineCode] = useState<string | undefined>(undefined);

  const airlines = useSelector(airlinesSelector);

  const airlineGroup = Object.keys(flightNumbersByAirline)?.map((o) => ({
    label: airlines?.[o].displayName,
    value: o,
  }));

  const flightNumber =
    airlineCode == null
      ? []
      : flightNumbersByAirline[airlineCode]?.map((n) => ({
          label: `${airlineCode} ${n}`,
          value: `${airlineCode} ${n}`,
        }));

  return (
    <div className={clsx(block, className)}>
      <RadioGroup
        options={airlineGroup}
        selectedOption={airlineCode}
        onSelectValue={(val) => {
          setAirlineCode(val);
        }}
        className={cn("airline")}
      />
      <CheckboxGroup
        options={flightNumber}
        checkedOptions={selectedFlightNumber.map(
          (f) => `${f.airlineCode} ${f.flightNumber}`
        )}
        onOptionsChange={(val) => {
          const newFiltered = val.map((v) => {
            const [airlineCode, flightNumber] = v.split(" ");
            return {
              airlineCode,
              flightNumber,
            };
          });
          onFlightNumberChange(newFiltered);
        }}
      />
    </div>
  );
};
